/** This file is auto generated by convertSvgToJsx.ts */

import icon from './dnb/scan_medium'
export default icon
